import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const IseGirisSaglikRaporuPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white overflow-hidden mt-20">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-32 h-32 border border-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-32 right-20 w-24 h-24 border border-white/10 rounded-full animate-pulse delay-1000"></div>
          <div className="absolute bottom-20 left-32 w-40 h-40 border border-white/10 rounded-full animate-pulse delay-2000"></div>
          <div className="absolute bottom-32 right-10 w-28 h-28 border border-white/10 rounded-full animate-pulse delay-500"></div>
        </div>

        <div className="container mx-auto px-4 h-full flex items-center relative z-10">
          <div className="max-w-4xl">
            <div className="mb-6">
              <span className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                ASSA OSGB Laboratuvar Hizmetleri
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              İşe Giriş Sağlık Raporu
            </h1>
            <p className="text-xl md:text-2xl text-blue-200 mb-8 leading-relaxed">
              Adana, Mersin, Hatay ve Osmaniye illerinde hızlı ve güvenilir işe giriş sağlık muayenesi hizmetleri
            </p>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/iletisim"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Randevu Al
              </Link>
              <Link 
                to="/laboratuvar/hizmet-laboratuvari"
                className="border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Diğer Hizmetler
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-red-600 font-medium">Kapsamlı Muayene</span>
            <h2 className="text-4xl font-bold text-gray-800 mt-2">İşe Giriş Sağlık Raporu Hizmetleri</h2>
            <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
              ASSA OSGB olarak, çalışanlarınızın işe başlamadan önce sağlık durumlarını değerlendiren 
              kapsamlı muayene hizmetleri sunuyoruz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Genel Muayene */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-stethoscope-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Genel Muayene</h3>
              <ul className="text-gray-700 space-y-2">
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-600 mr-2"></i>
                  Fizik muayene
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-600 mr-2"></i>
                  Vital bulgular kontrolü
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-600 mr-2"></i>
                  Sistem muayeneleri
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-600 mr-2"></i>
                  Sağlık geçmişi değerlendirmesi
                </li>
              </ul>
            </div>

            {/* Laboratuvar Testleri */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 border border-green-200 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-test-tube-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Laboratuvar Testleri</h3>
              <ul className="text-gray-700 space-y-2">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  Tam kan sayımı
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  Biyokimya paneli
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  İdrar analizi
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  Hepatit B-C testleri
                </li>
              </ul>
            </div>

            {/* Görüntüleme */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 border border-purple-200 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scan-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Görüntüleme</h3>
              <ul className="text-gray-700 space-y-2">
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-600 mr-2"></i>
                  Akciğer grafisi
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-600 mr-2"></i>
                  EKG çekimi
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-600 mr-2"></i>
                  Görme testleri
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-600 mr-2"></i>
                  İşitme testleri
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Muayene Süreci</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              İşe giriş sağlık raporu sürecimiz hızlı, güvenilir ve kapsamlı bir şekilde yürütülür.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Randevu Alma</h3>
              <p className="text-gray-600">
                Online veya telefon ile kolayca randevu alabilirsiniz. Hızlı ve pratik randevu sistemi.
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Muayene</h3>
              <p className="text-gray-600">
                Uzman doktorlarımız tarafından kapsamlı fizik muayene ve sağlık değerlendirmesi.
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Test ve Analiz</h3>
              <p className="text-gray-600">
                Gerekli laboratuvar testleri ve görüntüleme işlemleri modern cihazlarla yapılır.
              </p>
            </div>

            {/* Step 4 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
                4
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Rapor Teslimi</h3>
              <p className="text-gray-600">
                Sağlık raporunuz aynı gün içinde hazırlanır ve size teslim edilir.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Hizmet Bölgelerimiz</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              ASSA OSGB olarak Akdeniz ve Doğu Akdeniz bölgesinde geniş hizmet ağımızla yanınızdayız.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Adana */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8 text-center border border-red-200">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Adana</h3>
              <p className="text-gray-700 mb-4">
                Adana merkez ve ilçelerinde kapsamlı işe giriş sağlık raporu hizmetleri.
              </p>
              <div className="text-sm text-gray-600">
                <p>• Seyhan • Yüreğir</p>
                <p>• Çukurova • Sarıçam</p>
              </div>
            </div>

            {/* Mersin */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 text-center border border-blue-200">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Mersin</h3>
              <p className="text-gray-700 mb-4">
                Mersin ili genelinde hızlı ve güvenilir sağlık muayenesi hizmetleri.
              </p>
              <div className="text-sm text-gray-600">
                <p>• Akdeniz • Mezitli</p>
                <p>• Toroslar • Yenişehir</p>
              </div>
            </div>

            {/* Hatay */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 text-center border border-green-200">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Hatay</h3>
              <p className="text-gray-700 mb-4">
                Hatay ilinde modern laboratuvar imkanları ile sağlık raporu hizmetleri.
              </p>
              <div className="text-sm text-gray-600">
                <p>• Antakya • İskenderun</p>
                <p>• Defne • Arsuz</p>
              </div>
            </div>

            {/* Osmaniye */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 text-center border border-purple-200">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Osmaniye</h3>
              <p className="text-gray-700 mb-4">
                Osmaniye merkez ve çevresinde kaliteli sağlık muayenesi hizmetleri.
              </p>
              <div className="text-sm text-gray-600">
                <p>• Merkez • Kadirli</p>
                <p>• Düziçi • Bahçe</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img 
                  src="https://public.readdy.ai/ai/img_res/2f6af993d652716d2e8772574eb9d935.jpg" 
                  alt="Sağlık Muayenesi" 
                  className="w-full h-48 rounded-lg shadow-lg object-cover" 
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=Medical%20laboratory%20with%20modern%20testing%20equipment%2C%20blood%20samples%20and%20analysis%20machines%2C%20professional%20healthcare%20laboratory%20setting&width=300&height=200&seq=102&orientation=landscape" 
                  alt="Laboratuvar" 
                  className="w-full h-48 rounded-lg shadow-lg object-cover" 
                />
              </div>
              <div className="space-y-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Chest%20X-ray%20examination%20with%20radiologist%20and%20modern%20imaging%20equipment%2C%20medical%20diagnostic%20imaging%20in%20hospital%20setting&width=300&height=200&seq=103&orientation=landscape" 
                  alt="Görüntüleme" 
                  className="w-full h-48 rounded-lg shadow-lg object-cover" 
                />
                <img 
                  src="https://readdy.ai/api/search-image?query=Medical%20report%20and%20health%20certificate%20documents%20on%20desk%20with%20stethoscope%2C%20professional%20medical%20documentation%20and%20healthcare%20forms&width=300&height=200&seq=104&orientation=landscape" 
                  alt="Rapor" 
                  className="w-full h-48 rounded-lg shadow-lg object-cover" 
                />
              </div>
            </div>

            {/* Content */}
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Neden ASSA OSGB?</h2>
              <p className="text-gray-600 leading-relaxed mb-8">
                İşe giriş sağlık raporu hizmetlerimizde kalite, hız ve güvenilirlik önceliğimizdir. 
                Uzman kadromuz ve modern teknolojimizle çalışanlarınızın sağlığını koruyoruz.
              </p>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-user-heart-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Uzman Doktor Kadrosu</h3>
                    <p className="text-gray-600">
                      Alanında uzman doktorlarımız tarafından kapsamlı ve detaylı muayene hizmetleri.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-time-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Hızlı Sonuç</h3>
                    <p className="text-gray-600">
                      Sağlık raporlarınız aynı gün içinde hazırlanır ve size teslim edilir.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Güvenilir Hizmet</h3>
                    <p className="text-gray-600">
                      8+ yıllık deneyimimiz ve binlerce başarılı muayene ile güvenilir hizmet.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-microscope-line text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Modern Teknoloji</h3>
                    <p className="text-gray-600">
                      Son teknoloji laboratuvar cihazları ve görüntüleme sistemleri ile doğru sonuçlar.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">İşe Giriş Sağlık Raporu İçin</h2>
          <p className="text-xl text-blue-200 mb-8 max-w-2xl mx-auto">
            Hızlı randevu alın, aynı gün raporunuzu alın. ASSA OSGB güvencesi ile sağlıklı çalışma hayatına başlayın.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/iletisim"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Hemen Randevu Al
            </Link>
            <Link 
              to="/laboratuvar/hizmet-laboratuvari"
              className="border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Diğer Laboratuvar Hizmetleri
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default IseGirisSaglikRaporuPage;